import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
  // results slider
  const resultsSwiper = new Swiper('#results_section_sidebar .grid-results', {
    modules: [Navigation, Pagination, A11y],
    // navigation: {
    //   nextEl: '.arrow-next',
    //   prevEl: '.arrow-prev',
    // },
    pagination: {
      el: '#results_section_sidebar .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    // a11y: true,
    // keyboardControl: true,
    // grabCursor: true,
    // watchOverflow: true,


    a11y: true,
    autoHeight: true,
    keyboardControl: true,
    grabCursor: true,
    watchOverflow: true,
    // loop: true,
    observer: true,
    updateOnWindowResize: true,
  });
};
